/* eslint-disable jsx-a11y/anchor-is-valid */
// import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { NavBar } from './styles/NavBar.styled.js';
import { ShowCaseAbout } from './styles/ShowCase.styled.js';
// import { AboutCompany } from './styles/AboutCompany.styled';
// import CleaningOperation from './styles/CleaningOperation.styled.js';
import { OurCommitment } from './styles/SectorSpecialist.styled.js';
import { OurMission } from './styles/OurColleagues.styled.js';
import { WhyIntegrated } from './styles/CleaningESG.styled.js';
import mission from './assets/mission.jpg';
import commitment from './assets/commitment.jpg';
import whyChooseUs from './assets/whyChooseUs.jpg';

import { Footer } from './styles/Footer.styled.js';

// const stats = [
//   {
//     icon: 'fa-solid fa-soap',
//     target: 2,
//     suffix: 'Yrs',
//     text: 'History and experience in facilities services',
//   },
//   {
//     icon: 'fa-solid fa-earth-europe',
//     target: 35,
//     suffix: '+',
//     text: 'Colleagues across the UK',
//   },
//   {
//     icon: 'fa-solid fa-arrows-down-to-people',
//     target: 150,
//     suffix: '+',
//     text: 'clients supported across multiple sectors',
//   },
//   {
//     icon: 'fa-solid fa-recycle',
//     target: 1,
//     suffix: '+',
//     text: 'Group-wide shared vision and mission',
//   },
// ];

const About = () => {
  // const [counts, setCounts] = useState(stats.map(() => 0));

  // useEffect(() => {
  //   const timers = stats.map((stat, index) => {
  //     const increment = Math.ceil(stat.target / 100); // Adjust speed by changing divisor
  //     return setInterval(() => {
  //       setCounts((prev) => {
  //         const newCounts = [...prev];
  //         if (newCounts[index] < stat.target) {
  //           newCounts[index] = Math.min(
  //             newCounts[index] + increment,
  //             stat.target
  //           );
  //         }
  //         return newCounts;
  //       });
  //     }, 30); // Adjust interval for animation speed
  //   });

  //   return () => timers.forEach((timer) => clearInterval(timer));
  // }, []);

  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
        />
        <title>About - Welcome to Rade</title>
      </Helmet>
      <NavBar></NavBar>

      <main>
        <ShowCaseAbout>
          <div className="center">
            <div className="titleBox">
              <h1>Welcome to Rade</h1>
              <p>
                We are a global facilities services leader, supported by
                colleagues and trusted by clients across the UK.
              </p>
            </div>
          </div>
        </ShowCaseAbout>
        {/* <CleaningOperation>
          <div className="container">
            <div className="row">
              <div className="header">
                <h1>History, colleagues, clients and vision</h1>
                <p>
                  We’re on a mission to make people and places the best they can
                  be and we understand the critical importance of cleaning,
                  hygiene and infection control for your people.
                </p>
              </div>
              <div className="cleaning">
                <ul>
                  {stats.map((stat, index) => (
                    <li key={index}>
                      <i>
                        <i className={stat.icon}></i>
                      </i>
                      <h3>
                        {Math.floor(counts[index])}
                        {stat.suffix}
                      </h3>
                      <p>{stat.text}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </CleaningOperation> */}
        <WhyIntegrated>
          <div className="container">
            <div className="row">
              <div className="col_2">
                <h1>Why Integrated?</h1>
                <p>
                  The modern business landscape moves fast. Managing separate
                  contractors for specialized cleaning, facility upkeep, and
                  transportation support is inefficient. Rade simplifies your
                  operations by bringing these critical functions under one
                  expert roof. Our expertise is built on four core pillars,
                  reflected in our diverse industry certifications:
                </p>
                <ul>
                  <li>
                    <i class="fa-solid fa-circle-check"></i>
                    <p>
                      <span>Bespoke Logistics Support:</span> We provide the "last-mile" and
                      technical support activities that ensure your goods and
                      equipment move without friction.
                    </p>
                  </li>
                  <li>
                    <i class="fa-solid fa-circle-check"></i>
                    <p>
                      <span>Soft Facilities Management:</span> From daily operational
                      oversight to complex building support, we ensure your
                      workspace is an asset, not a liability.
                    </p>
                  </li>
                  <li>
                    <i class="fa-solid fa-circle-check"></i>
                    <p>
                      <span>Specialized Hygiene & Sanitization:</span> Moving beyond standard
                      cleaning, we provide technical and industrial-grade
                      services designed for high-stakes environments that
                      require precision and compliance.
                    </p>
                  </li>
                  <li>
                    <i class="fa-solid fa-circle-check"></i>
                    <p>
                      <span>Exceptional care for your home:</span> Whether you require a
                      noe-off deep clean or regular upkeep, we deliver the peace
                      of mind that comes with a truly immaculate space.
                    </p>
                  </li>
                </ul>
              </div>
              <div className="col_1">
                <img src={whyChooseUs} alt="" />
              </div>
            </div>
          </div>
        </WhyIntegrated>
        <OurCommitment>
          <div className="container">
            <div className="row">
              <div className="col_2">
                <h1>Our Commitment</h1>
                <p>
                  At Rade, our mission is simple: To handle the essential, so
                  you can focus on the exceptional. We combine local Sheffield
                  pride with a rigorous, professional approach to UK industry
                  standards, ensuring every site we touch is safer , cleaner ,
                  and more efficient than we found it.
                </p>
              </div>
              <div className="col_1">
                <img src={commitment} alt="responsibility" />
              </div>
            </div>
          </div>
        </OurCommitment>
        <OurMission>
          <div className="container">
            <div className="row">
              <div className="col_1">
                <img src={mission} alt="Operation" />
              </div>
              <div className="col_2">
                <h1>Our Mission</h1>
                <p>
                  At Rade Integrated Services Ltd, our mission is to redefine the
                  standard of operational support by creating seamless,
                  high-performance environments for the businesses of tomorrow.
                  Founded in 2025, we were built on the belief that a company’s success is anchored in the quality of its foundations. From
                  the precision of our specialized hygiene to the fluidity of
                  our logistics support, we integrate the essential services
                  that empower our clients to innovate, grow , and lead with
                  confidence.
                </p>
              </div>
            </div>
          </div>
        </OurMission>
        {/* <AboutCompany>
          <div className="container">
            <div className="col-1">
              <h3>About Company</h3>
              <h1>New Generation of Cleaning And Restoration Concepts.</h1>
            </div>
            <div className="col-2">
              <div className="first">
                <p>
                  At Rade Integrated Services Ltd, we take pride in delivering
                  exceptional cleaning services tailored to meet the diverse
                  needs of our valued clients. With a strong commitment to
                  excellence, reliability, and customer satisfaction, we have
                  established ourselves as a premier cleaning service provider
                  in the industry. Backed by a team of skilled and experienced
                  professionals, we specialize in a wide range of cleaning
                  services. Our comprehensive offerings cater to both
                  residential and commercial spaces, ensuring that every corner
                  is left spotless and sparkling. We understand the importance
                  of a clean and organized environment in enhancing the quality
                  of life and productivity. That's why we go above and beyond to
                  deliver top-notch cleaning solutions that exceed our clients'
                  expectations and create a welcoming and hygienic space for
                  all. With a customer-centric approach, attention to detail,
                  and a dedication to quality, Rade Integrated Services Ltd is
                  your go-to partner for all your cleaning needs. Let us handle
                  the dirty work while you sit back, relax, and enjoy the
                  pristine results of our professional cleaning services.
                </p>
              </div>
              <div className="second">
                <ul>
                  <li>
                    <span>
                      <i class="fa-solid fa-circle-check"></i>
                    </span>
                    <span>
                      Regular weekly, fortnightly, four weekly domestic home
                      cleaning.
                    </span>
                  </li>
                  <li>
                    <span>
                      <i class="fa-solid fa-circle-check"></i>
                    </span>
                    <span>
                      Flexibility to meet ‘short notice’ cleaning requirements.
                    </span>
                  </li>
                  <li>
                    <span>
                      <i class="fa-solid fa-circle-check"></i>
                    </span>
                    <span>
                      Team leader supervision at house cleans ensuring quality
                      of service.
                    </span>
                  </li>
                  <li>
                    <span>
                      <i class="fa-solid fa-circle-check"></i>
                    </span>
                    <span>
                      Collections and return of property keys to owner / agent.
                    </span>
                  </li>
                  <li>
                    <span>
                      <i class="fa-solid fa-circle-check"></i>
                    </span>
                    <span>
                      Fully trained, uniformed and employed cleaning teams.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </AboutCompany> */}
      </main>
      <Footer></Footer>
    </>
  );
};

export default About;
